<template>
  <div class="ficha-mapa ficha-area-de-estudio">
    <div class="encabezado">Áreas de estudio</div>
    <div class="contenedor">
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha1/1-Porcion de la RNCOM.png"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Porción de la RNOCM</p>
          </div>
          <div class="ficha-titulo">
            <h4>Región Nororiental de la Cuenca de México (RNOCM)</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Área de estudio conformada por la porción noreste del Estado de
              México, el sur de Hidalgo, el poniente de Tlaxcala y el nororiente
              y sureste de la Ciudad de México.
              <b
                >Para la delimitación de esta región se consideraron diversos
                eventos económicos y sociales</b
              >, así como la información disponible. La RNOCM abarca una
              superficie de 638,374.8 ha.
            </p>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha1/2-Laguna de Xalapango.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Laguna de Xalapango</p>
          </div>
          <div class="ficha-titulo">
            <h4>Subcuenca de Texcoco</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Tiene una superficie de 139,400 ha y presenta una disponibilidad
              media anual de 0.05 hm³.
              <b>Se ubica en la parte centro de la RNOCM</b> y abarca desde la
              parte alta del cerro Tláloc, en la Sierra Nevada, donde nacen los
              ríos Coatepec, Santa Mónica, San Bernardino, Chapingo, Texcoco,
              Coxcacoaco, Xalapango y Papalotla y la parte noreste del Valle de
              México, donde nace el Río San Juan Teotihuacán, hasta la zona del
              Exlago de Texcoco (Conagua, 2008).
            </p>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha1/3-Zona de influencia PELT.png"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Zona de influencia PELT</p>
          </div>
          <div class="ficha-titulo">
            <h4>
              Zona de influencia del Parque Ecológico del Lago de Texcoco (PELT)
            </h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Se compone de
              <b>ocho municipios del Estado de México:</b> Acolman, Atenco,
              Chimalhuacán, Ecatepec de Morelos, Nezahualcóyotl, Texcoco,
              Tezoyuca, Tlalnepantla de Baz; y
              <b>dos alcaldías de la Ciudad de México:</b> Gustavo A. Madero y
              Venustiano Carranza. Divisiones administrativas que rodean al
              PELT. La superficie de la zona de influencia es de 102,891.0 ha.
            </p>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha1/4-ZFLT.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Zona Federal del Lago de Texcoco</p>
          </div>
          <div class="ficha-titulo">
            <h4>Zona Federal del Lago de Texcoco (ZFLT)</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Área de propiedad nacional desde 1922. Se ubica en el Estado de
              México, dentro de los municipios de Texcoco, San Salvador Atenco,
              Nezahualcóyotl, Chimalhuacán y Ecatepec, al oriente de la Ciudad
              de México. La ZFLT tiene una superficie de 11,600 ha. Actualmente,
              se prevé que ahí se construya el PELT.
            </p>
          </div>
        </div>
      </div>

      <div class="ficha-separador"></div>

      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              class="foto"
              src="@/assets/fichas-diagnostico/ficha1/5-NAIM.jpg"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Estado actual de la obra del exNAICM</p>
          </div>
          <div class="ficha-titulo">
            <h4>Obra principal exNAICM Terminal</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              La superficie de la obra abarcó 4,403 ha. Sin embargo, las
              repercusiones persisten en diversas escalas y esferas de la
              dinámica social y ecológica regional.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AreasDeEstudio",
};
</script>
